<template>
  <div v-pageBuried data-page-buried="BG_XIUGAIJIHUA">
    <div class="edit-page" :style="{ height: screenHeight + 'px' }" v-if="plan">
      <AppNavBar
        title="修改计划"
        :placeholder="true"
        :options="options"
      ></AppNavBar>
      <div class="edit-container">
        <div class="edit-scroll">
          <div class="edit-content">
            <div class="custom-title">
              <div class="title">计划名称</div>
              <div>
                <van-field
                  v-model="plan.plan_title"
                  placeholder="请输入计划名称"
                  @blur="bindInputBlur"
                  @click="bindInputClick"
                  :disabled="plan.type != 1"
                >
                </van-field>
              </div>
            </div>
            <div>
              <div class="title">时间设置</div>
              <div class="bj-list">
                <div
                  class="bj-item"
                  v-for="(item, index) in plan.list"
                  :key="index"
                >
                  <div class="bj-item-top">
                    <img
                      class="bj-item-image"
                      :src="item.p_image"
                      alt=""
                      @click="bindClickTonicItem(item)"
                    />
                    <div class="bj-item-top-center">
                      <div class="bj-item-name">{{ item.p_title }}</div>
                      <div class="bj-item-bottom">
                        <img
                          class="bj-item-brand"
                          :src="item.brand_img"
                          alt=""
                        />
                        <div class="bj-item-desc"
                          >{{ item.daily_times }}次/日·{{ item.every_times_num
                          }}{{ item.min_unit_txt }}/次 ·
                          {{ item.take_suggested_time_txt }}</div
                        >
                      </div>
                    </div>
                    <div
                      class="delete iconfont icon-shanchu"
                      @click="deleteEatTime(item)"
                      v-if="plan.type == 1"
                    ></div>
                  </div>
                  <div class="bj-item-time-list">
                    <div
                      class="bj-item-time-item"
                      v-for="(item1, index1) in item.time_list"
                      :key="index1"
                      @click="bindClickTime(item, item1)"
                    >
                      <div class="item-time"
                        >{{ item1.eat_hour | filterTimeFillZero }}:{{
                          item1.eat_minute | filterTimeFillZero
                        }}</div
                      >
                      <div
                        ><span class="item-unit"
                          >{{ item.every_times_num
                          }}{{ item.min_unit_txt }}</span
                        ><span class="iconfont icon-you"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="operate-container">
        <div
          class="btn-item add-btn"
          @click="bindAddTonic"
          v-if="plan.type == 1"
          v-buried
          data-buried="BG_BUTTON_XIUGAIJIHUA_ADD"
          v-clickBuried
          data-click-buried="CLICK_BUTTON_XIUGAIJIHUA_ADD"
          ><span class="iconfont icon-jiahao"></span>添加服用品</div
        >
        <div class="btn-item replace-btn" @click="bindReplacePlan"
          >更换计划</div
        >
        <div class="btn-item stop-btn" @click="bindStopPlan">停止计划</div>
      </div>
    </div>
    <van-popup v-model="showEditToast" round position="bottom">
      <EditTime
        :data="timeData"
        :editData="curEditData"
        @save="editEatTime"
        @cancel="bindCancelEditTime"
      />
    </van-popup>
    <van-popup
      v-model="showTonicDetail"
      position="bottom"
      round
      class="plan-list-popup"
    >
      <TonicDetail :id="tonicId" v-if="showTonicDetail" />
    </van-popup>
    <CommonToast
      v-model="showCommonToast"
      :options="commonToastData"
      @confirm="bindDefaultConfirm"
      @cancel="bindDefaultCancel"
    />
  </div>
</template>

<script>
import TonicDetail from './components/tonic-detail.vue'
import AppNavBar from '@/components/app/nav-bar/index.vue'
import EditTime from './components/edit-time.vue'
import CommonToast from './components/common-toast.vue'
export default {
  components: { AppNavBar, EditTime, CommonToast, TonicDetail },
  data() {
    return {
      options: {},
      screenHeight: 0,
      planId: 0,
      _originInput: '',
      timeData: ['00', '00'],
      plan: null,
      showEditToast: false,
      curEditData: null, //当前编辑时间的补剂数据
      showCommonToast: false,
      commonToastData: {
        title: '停止计划',
        message: '停止计划后小闹就不能按时提醒您吃补剂了哦',
        confirmButtonText: '确认停止'
      },
      tonicId: 0,
      showTonicDetail: false
    }
  },
  filters: {
    filterTimeFillZero(time) {
      return time > 9 ? time : '0' + time
    }
  },
  created() {
    this.screenHeight = window.screen.height
    let planData = this.$store.state.nutritionClock.planData
    if (planData) {
      this.planId = planData.plan_id
    }
    this.getPlanList()
  },
  methods: {
    bindClickTonicItem(item) {
      this.tonicId = item.product_id
      this.showTonicDetail = true
    },
    bindInputClick() {
      this._originInput = this.plan.plan_title
    },
    bindDefaultConfirm() {
      this.showCommonToast = false
    },
    bindDefaultCancel() {
      this.showCommonToast = false
    },
    bindClickTime(item, item1) {
      let hours = item1.eat_hour > 9 ? item1.eat_hour : '0' + item1.eat_hour
      let min = item1.eat_minute > 9 ? item1.eat_minute : '0' + item1.eat_minute
      this.curEditData = item
      this.curEditTimeData = item1
      this.timeData = [hours, min]
      this.showEditToast = true
    },
    /* 获取自定义计划时间列表 */
    async getPlanList() {
      let params = {
        plan_id: this.planId
      }
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/tonicPlanEditDetail', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.plan = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async stopPlan() {
      let params = {
        plan_id: this.planId
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/stopPlan', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('停止成功')
          setTimeout(() => {
            this.$http.appBack()
          }, 500)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    /* 更换计划 */
    bindReplacePlan() {
      this.$router.push('/nutrition-clock/plan-list')
    },
    /* 停止计划 */
    bindStopPlan() {
      this.commonToastData = {
        title: '停止计划',
        message: '停止计划后小闹就不能按时提醒您吃补剂了哦😭～',
        confirmButtonText: '确认停止'
      }
      this.bindDefaultConfirm = this.bindStopPlanConfirm
      this.showCommonToast = true
    },
    bindStopPlanConfirm() {
      this.showCommonToast = false
      this.stopPlan()
    },
    bindInputBlur() {
      if (this._originInput != this.plan.plan_title && this.plan.plan_title) {
        this.editPlanName(this.plan.plan_title)
      } else {
        this.plan.plan_title = this._originInput
      }
    },
    /* 编辑计划名称 */
    async editPlanName(name) {
      let params = {
        plan_id: this.planId,
        title: name
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/editPlanTitle', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('编辑成功')
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindCancelEditTime() {
      this.showEditToast = false
    },
    /* 编辑服用时间 */
    async editEatTime(timeValues) {
      let id = this.curEditTimeData.time_id
      let ruleId = this.curEditData.rule_id
      let params = {
        plan_id: this.planId,
        usage_time_id: id, //服用时间主键id
        usage_rule_id: ruleId,
        eat_hour: timeValues[0],
        eat_minute: timeValues[1]
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/editProductEatTime', params)
        .catch(() => {})
      this.showEditToast = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('编辑成功')
          this.getPlanList()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    /* 删除某个补剂 */
    deleteEatTime(item) {
      if (this.plan.list.length <= 1) {
        this.$toast('至少保留一个补剂产品')
        return
      }
      this.commonToastData = {
        title: '删除补剂',
        message: '',
        confirmButtonText: '确认删除'
      }
      this.curDeleteTonicData = item
      this.bindDefaultConfirm = this.deleteTonic
      this.showCommonToast = true
    },
    /* 删除补剂接口 */
    async deleteTonic() {
      this.showCommonToast = false
      let params = {
        plan_id: this.planId,
        usage_rule_id: this.curDeleteTonicData.rule_id
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/delUsageRule', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('删除成功')
          this.getPlanList()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    /* 添加补剂 */
    bindAddTonic() {
      this.$router.push({
        path: '/nutrition-clock/select',
        query: {
          planId: this.planId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-page {
  background-color: rgba(249, 249, 249, 1);
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .edit-container {
    padding: 0px 16px;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    margin-bottom: 10px;

    ::v-deep .van-cell {
      border-radius: 8px;
    }

    ::v-deep .van-field__control {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.5);
    }

    .edit-scroll {
      height: 100%;
      overflow-y: scroll;

      .edit-content {
        padding-bottom: 27px;
      }
    }

    .custom-title {
      margin-top: 36px;
      margin-bottom: 15px;
      .iconfont {
        font-size: 20px;
      }
    }

    .title {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 8px;
    }

    .bj-list {
      .bj-item {
        background: #ffffff;
        border-radius: 8px;
        padding: 14px;
        margin-bottom: 10px;

        .bj-item-top {
          display: flex;
          align-items: center;
          margin-bottom: 16px;

          .bj-item-image {
            width: 40px;
            height: 40px;
            object-fit: contain;
            background: #ffeeee;
            border-radius: 6px;
            margin-right: 10px;
          }

          .bj-item-top-center {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;

            .bj-item-name {
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.8);
              line-height: 18px;
              margin-bottom: 6px;
            }

            .bj-item-bottom {
              display: flex;
              align-items: center;

              .bj-item-brand {
                width: 40px;
                height: 14px;
                border-radius: 2px;
                box-sizing: border-box;
                border: 0.5px solid #dddddd;
                box-sizing: border-box;
                margin-right: 6px;
              }

              .bj-item-desc {
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                color: rgba(0, 0, 0, 0.5);
                line-height: 17px;
              }
            }
          }

          .delete {
            border-radius: 50%;
            width: 24px;
            height: 24px;
            font-size: 14px;
            box-sizing: border-box;
            background: #ffffff;
            border: 1px solid #f1f1f1;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgb(108, 108, 108);
          }
        }

        .bj-item-time-list {
          .bj-item-time-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .item-time {
              font-size: 24px;
              font-family: DINPro, DIN;
              color: rgba(0, 0, 0, 0.8);
              line-height: 26px;
            }

            .item-unit {
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 17px;
              margin-right: 10px;
            }

            .iconfont {
            }
          }

          .bj-item-time-item:last-child {
            margin-bottom: 0;
          }
        }
      }

      .bj-item:last-child {
        margin-bottom: 0;
      }
    }
  }

  .operate-container {
    padding: 0px 16px;
    @include paddingBottom(20px);

    .btn-item {
      text-align: center;
      height: 48px;
      background: #ffffff;
      border-radius: 24px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.5);
      line-height: 48px;
      margin-bottom: 14px;
    }

    .btn-item:last-child {
      margin-bottom: 0;
    }

    .replace-btn {
      color: #00cddf;
    }

    .add-btn {
      background: #03d4e6;
      color: #ffffff;

      .iconfont {
        margin-right: 4px;
      }
    }
  }
}
</style>
